/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccessRequestAppExternalConnection } from './AccessRequestAppExternalConnection';
import {
    AccessRequestAppExternalConnectionFromJSON,
    AccessRequestAppExternalConnectionFromJSONTyped,
    AccessRequestAppExternalConnectionToJSON,
    AccessRequestAppExternalConnectionToJSONTyped,
} from './AccessRequestAppExternalConnection';

/**
 * 
 * @export
 * @interface AccessRequestsAppAccessRule
 */
export interface AccessRequestsAppAccessRule {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRule
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRule
     */
    organization_id: string;
    /**
     * Person ID
     * @type {string}
     * @memberof AccessRequestsAppAccessRule
     */
    person_id: string;
    /**
     * 
     * @type {AccessRequestAppExternalConnection}
     * @memberof AccessRequestsAppAccessRule
     */
    app_external_connection: AccessRequestAppExternalConnection;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRule
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRule
     */
    app_url?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRule
     */
    identifier_from_source: string;
    /**
     * 
     * @type {Date}
     * @memberof AccessRequestsAppAccessRule
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AccessRequestsAppAccessRule
     */
    last_updated_at?: Date;
}

/**
 * Check if a given object implements the AccessRequestsAppAccessRule interface.
 */
export function instanceOfAccessRequestsAppAccessRule(value: object): value is AccessRequestsAppAccessRule {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('person_id' in value) || value['person_id'] === undefined) return false;
    if (!('app_external_connection' in value) || value['app_external_connection'] === undefined) return false;
    if (!('identifier_from_source' in value) || value['identifier_from_source'] === undefined) return false;
    return true;
}

export function AccessRequestsAppAccessRuleFromJSON(json: any): AccessRequestsAppAccessRule {
    return AccessRequestsAppAccessRuleFromJSONTyped(json, false);
}

export function AccessRequestsAppAccessRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestsAppAccessRule {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organization_id': json['organization_id'],
        'person_id': json['person_id'],
        'app_external_connection': AccessRequestAppExternalConnectionFromJSON(json['app_external_connection']),
        'description': json['description'] == null ? undefined : json['description'],
        'app_url': json['app_url'] == null ? undefined : json['app_url'],
        'identifier_from_source': json['identifier_from_source'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'last_updated_at': json['last_updated_at'] == null ? undefined : (new Date(json['last_updated_at'])),
    };
}

export function AccessRequestsAppAccessRuleToJSON(json: any): AccessRequestsAppAccessRule {
    return AccessRequestsAppAccessRuleToJSONTyped(json, false);
}

export function AccessRequestsAppAccessRuleToJSONTyped(value?: AccessRequestsAppAccessRule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organization_id': value['organization_id'],
        'person_id': value['person_id'],
        'app_external_connection': AccessRequestAppExternalConnectionToJSON(value['app_external_connection']),
        'description': value['description'],
        'app_url': value['app_url'],
        'identifier_from_source': value['identifier_from_source'],
        'created_at': value['created_at'] == null ? value['created_at'] : value['created_at'].toISOString(),
        'last_updated_at': value['last_updated_at'] == null ? value['last_updated_at'] : value['last_updated_at'].toISOString(),
    };
}

